export enum AuditTypeTarget {
    Database = "Database",
    Operation = "Operation"
}
